import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const departmentApi = createApi({
  reducerPath: "departmentApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_BASE_URL,
    credentials: "include",
  }),
  tagTypes: ["Department"],
  endpoints: (builder) => ({
    // ➕ Create Department
    addDepartment: builder.mutation({
      query: (newDept) => ({
        url: "/departments/create",
        method: "POST",
        body: newDept,
      }),
      invalidatesTags: ["Department"],
    }),

    // 📋 Get All Departments
    getAllDepartments: builder.query({
      query: ({ page = 1, limit = 10, search = "", company, active } = {}) => {
        const params = { page, limit, q: search };
        if (company) params.company = company;
        if (typeof active === "boolean") params.active = active;
        return { url: "/departments", params };
      },
      providesTags: ["Department"],
    }),

    // 🆔 Get Department by ID
    getDepartmentById: builder.query({
      query: (id) => `/departments/${id}`,
      providesTags: (_res, _err, id) => [{ type: "Department", id }],
    }),

    // ✏️ Update Department
    updateDepartment: builder.mutation({
      query: ({ id, ...patch }) => ({
        url: `/departments/${id}`,
        method: "PUT",
        body: patch,
      }),
      invalidatesTags: ["Department"],
    }),

    // 🗑️ Delete Department
    deleteDepartment: builder.mutation({
      query: (id) => ({
        url: `/departments/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Department"],
    }),

    // 🟢 Activate Department
    activateDepartment: builder.mutation({
      query: (id) => ({
        url: `/departments/${id}/activate`,
        method: "PATCH",
      }),
      invalidatesTags: ["Department"],
    }),

    // 🔴 Deactivate Department
    deactivateDepartment: builder.mutation({
      query: (id) => ({
        url: `/departments/${id}/deactivate`,
        method: "PATCH",
      }),
      invalidatesTags: ["Department"],
    }),
  }),
});

export const {
  useAddDepartmentMutation,
  useGetAllDepartmentsQuery,
  useGetDepartmentByIdQuery,
  useUpdateDepartmentMutation,
  useDeleteDepartmentMutation,
  useActivateDepartmentMutation,
  useDeactivateDepartmentMutation,
} = departmentApi;

export default departmentApi;
